import { Link, useParams } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSingleLanguageFunc } from "../../../store/custom-actions/language/GetSingleLanguageSlicer";
import { autoTranslateLanguageFunc } from "../../../store/custom-actions/language/AutoTranslateLanguageSlicer";
import SpinnerLoading from "../../components/spinner-loading/SpinnerLoading";
import FaildLoadData from "../../global-components/FaildLoadData/FaildLoadData";
import NewTextForm from "../../custom-forms/settings-pages/languages/NewTextForm";
import { useTranslation } from "react-i18next";
import TranslateCard from "./TranslateCard";
import SearchBox from "../../components/ui/SearchBox";

export default function UpdateLanguageWordsPage() {
  const { t } = useTranslation();
  const { langId } = useParams();
  const dispatch = useDispatch();

  const { loading, data: singleLangData } = useSelector(
    (state) => state.getSingleLanguageSlicer
  );

  const { loading: autoTransLoading, data: autoTransData } = useSelector(
    (state) => state.autoTranslateLanguageSlicer
  );

  const [langWords, setLangWords] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [showNewTextForm, setShowNewTextForm] = useState(false);

  // Fetch language data
  const fetchLanguage = useCallback(() => {
    dispatch(getSingleLanguageFunc(langId));
  }, [dispatch, langId]);

  useEffect(() => {
    fetchLanguage();
  }, [fetchLanguage]);

  useEffect(() => {
    if (singleLangData?.all_word) {
      setLangWords(singleLangData.all_word);
    }
  }, [singleLangData]);

  // Search logic
  const handleSearch = () => {
    const value = searchValue.trim();
    if (!value) {
      return;
    }

    const filtered = Object.entries(singleLangData?.all_word || {}).filter(
      ([key, val]) =>
        key.toLowerCase().includes(value.toLowerCase()) ||
        val.toLowerCase().includes(value.toLowerCase())
    );

    setLangWords(Object.fromEntries(filtered));
  };

  // Auto translate
  const handleAutoTranslate = () => {
    dispatch(
      autoTranslateLanguageFunc({
        id: langId,
        payload: {},
      })
    ).then(() => {
      fetchLanguage();
    });
  };

  const renderCards = () => {
    return (
      <>
        {Object.entries(langWords).map(([key, value]) => (
          <div key={key} className="col-12 col-md-6 col-lg-4">
            <TranslateCard
              stringKey={key}
              initialValue={value}
              langId={langId}
            />
          </div>
        ))}
      </>
    );
  };

  return (
    <>
      <PageTitle motherMenu="Language" activeMenu="Tranlsate Words" />

      <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
        <div className="col-12 col-md-6 mb-2 mb-md-0">
          <SearchBox
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            onSearch={handleSearch}
          />
        </div>
        <div className="d-flex gap-2">
          <button
            onClick={() => setShowNewTextForm(true)}
            className="btn btn-primary btn-sm"
          >
            {t("Create")}
          </button>

          <button
            onClick={handleAutoTranslate}
            className="btn btn-success btn-sm"
            disabled={autoTransLoading}
          >
            {autoTransLoading ? t("Translating...") : t("Auto Translate")}
          </button>
        </div>
      </div>

      {loading ? (
        <SpinnerLoading />
      ) : singleLangData ? (
        <div className="row g-3">
          {Object.keys(langWords).length > 0 ? (
            renderCards()
          ) : (
            <p className="text-center py-5 text-muted">{t("No words found")}</p>
          )}
        </div>
      ) : (
        <FaildLoadData />
      )}

      <NewTextForm
        show={showNewTextForm}
        hide={() => setShowNewTextForm(false)}
        refetetchFunc={fetchLanguage}
        langSlug={singleLangData?.language?.slug}
      />

      {autoTransData?.done === true && (
        <p className="text-success mt-3 small text-center">
          {t("Auto translate completed successfully")}
        </p>
      )}
    </>
  );
}
